import { IRestfulConfigMap } from "../../common/data-access/restful/restful-config-map";
import { envConfig } from "../../environments/env-config";

let instanceServiceConfig: IRestfulConfigMap = {
    "instanceService": {
        appPath: envConfig.appPath("cgp"),
        isAuth: true,
        actions: {
            "updateOrder": {
                method: "PUT",
                path: "/api/woocommerce/orders/:orderId",
                paramDefaults: {
                    orderId: "@orderId"
                }
            },
        }
    }
}

type ActionKey = "updateOrder";

export { instanceServiceConfig };

export type { ActionKey };